import { useSDK } from '@metamask/sdk-react';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLoadingState } from '../../hooks/useLoader';
import { useWallet } from '@solana/wallet-adapter-react';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useController, useForm } from 'react-hook-form';
import Overlay from '../../ui/Overlay';
import Dropdown from '../../ui/Dropdown';
import Loader from '../../ui/Loader';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import { fetchChainDetails, getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import mintedAnimation from '../../assets/greenpill/mintedAnimation.gif';
import { getMintPriceForEVM, getMintTransaction, mintNFT } from '../../apis/geenpills/mintNFT';
import { RPC_ENDPOINT_L } from '../../constants/apiPaths';
import { Connection } from '@solana/web3.js';
import { BrowserProvider, formatEther } from 'ethers';
import { getChains, getTokens } from '../../apis/general/general';
import walletimage from '../../assets/walletimage.png';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import { useGlobalState } from '../../contexts/GlobalState';
import { useHome } from '../../contexts/HomeContext';
import ChangeWallet from './ChangeWallet';
import { updateWallet } from '../../apis/geenpills/updateWallet';
import GradientBorder from '../../ui/GradientBorder';
function MintNFTModal({ close, contractAddresses }) {
    const myRef = useRef({ close });
    const { dispatch } = useContext(AuthContext);
    const [linkingWalletModal, setLinkingWalletModal] = useState({
        from: '',
        type: '',
    });

    const { account } = useSDK();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state: landscapesState } = useGlobalState();
    const wallet = useWallet();
    const { fetchData } = useHome();

    const [chains, setChains] = useState([]);
    const [isMinted, setIsMinted] = useState(false);
    const { state } = useContext(AuthContext);
    const userProfile = state.user[0];

    const allowedChains = contractAddresses?.map((contract) => contract?.chainId);
    // useAutoSelectPhantom(close)
    const {
        register,
        handleSubmit,
        control,
        getValues,
        trigger,
        formState: { errors },
        setError,
        reset,
        setValue,

        clearErrors,
    } = useForm({
        mode: 'onChange',
    });

    const { field: tokenField } = useController({
        name: 'token',
        control,
        rules: { required: 'Please choose a token' },
    });
    const { field: landscapeField } = useController({
        name: 'landscape',
        control,
        rules: { required: 'Please choose a landscape' },
    });
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    // integrate an api for chain and then filter the deta
                    //get /blockchain

                    const response2 = await getChains();
                    console.log(response2, 'response');

                    setChains(response2?.data?.filter((c) => c?.name !== 'solana'));
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();

            function handleClick(e) {
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close]
    );

    useEffect(() => {
        function handleClickOutside(e) {
            // Close the modal if the click is outside the modal content
            if (myRef.current && !myRef.current.contains(e.target)) {
                close();
            }
        }

        // Add the event listener to close modal on outside click
        document.addEventListener('mousedown', handleClickOutside, true);

        // Clean up the event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [close]);

    const linkHandler = async (type) => {
        if (type === 'metamask') {
            const metaMaskProvider = getMetaMaskProvider();
            if (!metaMaskProvider) {
                const installUrl = 'https://metamask.io/download.html';
                toast.info('Opening MetaMask installation page in a new tab...');
                window.open(installUrl, '_blank'); // Open the URL in a new tab
                // toast.error('MetaMask is not installed or unavailable');
                return;
            }
            const accounts = await metaMaskProvider.request({
                method: 'eth_requestAccounts',
            });
            console.log(accounts);
            if (!accounts || accounts.length === 0) {
                toast.error('Failed to connect wallet');
                return;
            }

            const newWallet = accounts[0]?.toLowerCase();

            const response = await updateWallet(newWallet, undefined);
            if (response?.response?.data?.code === 400) {
                toast?.error(response?.response?.data?.message);
            }

            if (response?.evmAddress) {
                // toast?.success('Wallet changed successfully');
                dispatch({ type: 'changeWalletEVM', payload: newWallet });
                // or 'phantom' depending on type
            }
        }
    };
    const onSubmit = async (data) => {
        console.log(data, 'data');
        const { landscape } = data;
        const { contractAddresses } = landscape;
        const selectedContract = contractAddresses?.find(
            (contract) => contract.chainName?.toLowerCase() === data?.token?.name?.toLowerCase()
        );

        const { chainId, contractAddress, chainName } = selectedContract;

        if (chainName === 'solana') {
            console.log('0>>>>>>>');
            const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
            console.log('1>>>>>>>', phantom);
            if (phantom.adapter?.name !== 'Phantom') {
                console.log('2>>>>>>>');
                await wallet.select(phantom.adapter.name);
            }
            console.log('3>>>>>>>');
            if (!phantom.adapter.connected) {
                console.log('4>>>>>>>');
                await phantom.adapter.connect();
                console.log('5>>>>>>>');
            }

            // Continue with minting logic...
            const { stateURIsForSolana, name, solanaTreasuryWalletAddress } = landscape;
            const metadataUri = stateURIsForSolana[1];
            const collectionMintString = selectedContract?.collectionAddress;

            try {
                console.log('6>>>>>>>');
                const connection = new Connection(RPC_ENDPOINT_L, 'confirmed');
                startLoading();
                console.log('7>>>>>>>');
                const transaction = getMintTransaction(
                    metadataUri,
                    name,
                    collectionMintString,
                    solanaTreasuryWalletAddress,
                    connection,
                    phantom?.adapter
                );
                console.log('8>>>>>>>');
                const signature = await phantom.adapter.sendTransaction(transaction, connection);
                console.log('9>>>>>>>');

                const confirmResult = await connection.confirmTransaction(signature, 'confirmed');

                if (confirmResult?.value?.err !== null) {
                    toast.error(confirmResult?.value?.err);
                    return;
                } else {
                    setTimeout(fetchData, 3000);
                    setIsMinted(true);
                    setTimeout(() => {
                        close();
                    }, 5000);
                }
            } catch (error) {
                console.log(error, 'see the error');
            } finally {
                stopLoading();
            }

            return;
        } else {
            try {
                startLoading();

                const metaMaskProvider = getMetaMaskProvider();
                if (!metaMaskProvider) {
                    const installUrl = 'https://metamask.io/download.html';
                    toast.info('Opening MetaMask installation page in a new tab...');
                    window.open(installUrl, '_blank'); // Open the URL in a new tab
                    // toast.error('MetaMask is not installed or unavailable');
                    return;
                }
                const accounts = await metaMaskProvider.request({
                    method: 'eth_requestAccounts',
                });
                console.log(accounts);
                if (!accounts || accounts.length === 0) {
                    toast.error('Failed to connect wallet');
                    return;
                }

                const newWallet = accounts[0]?.toLowerCase();
                const existingWallet = userProfile?.evmAddress?.toLowerCase();

                if (!existingWallet) {
                    const response = await updateWallet(newWallet, undefined);
                    if (response?.response?.data?.code === 400) {
                        toast?.error(response?.response?.data?.message);
                    }

                    if (response?.evmAddress) {
                        // toast?.success('Wallet changed successfully');
                        dispatch({ type: 'changeWalletEVM', payload: newWallet });
                        // or 'phantom' depending on type
                    }
                } else if (newWallet !== existingWallet) {
                    handleChangeWalletAddress('mint', 'metamask');
                    return;
                }

                const userChainId = await metaMaskProvider.request({
                    method: 'eth_chainId',
                });
                const targetChainId = `0x${parseInt(chainId, 10).toString(16)}`; // Convert to hex string

                if (userChainId !== targetChainId) {
                    try {
                        // Attempt to switch to the correct chain
                        await metaMaskProvider.request({
                            method: 'wallet_switchEthereumChain',
                            params: [{ chainId: targetChainId }],
                        });
                        toast.success(`Switched to chain ID: ${targetChainId}`);
                    } catch (switchError) {
                        // Handle the case where the chain is not added or user rejects the switch

                        if (switchError.code === 4902) {
                            // 4902: Chain not added to MetaMask
                            try {
                                const chainDetails = await fetchChainDetails(chainId);
                                await metaMaskProvider.request({
                                    method: 'wallet_addEthereumChain',
                                    params: [chainDetails],
                                });
                                toast.success(`Added and switched to chain ID: ${targetChainId}`);
                            } catch (addError) {
                                toast.error('Failed to add or switch to the required chain');
                                return;
                            }
                        } else {
                            toast.error('Please change your chain network manually');
                            return;
                        }
                    }
                }

                const provider = new BrowserProvider(metaMaskProvider);

                const signer = await provider.getSigner();
                const address = await signer.getAddress();
                const balance = await provider.getBalance(address);
                const balanceEth = parseFloat(formatEther(balance));

                const requiredEth = await getMintPriceForEVM(contractAddress, chainId);

                if (balanceEth < requiredEth) {
                    toast.error(`Insufficient ETH: You need at least ${requiredEth} ETH`);
                    return;
                }

                const { success, code, result } = await mintNFT(contractAddress, chainId);

                if (!success) {
                    // toast.error(`May be winner has not linked metamask wallet in his "Impact Miner" account`);

                    toast.error(code);
                    return;
                }
                if (success) {
                    // integrate api to register funding

                    setTimeout(() => {
                        fetchData();
                    }, 3000);

                    setIsMinted(true);
                    setTimeout(() => {
                        close();
                    }, 5000);
                }
            } catch (err) {
                console.warn('Failed to connect..', err);
                toast.error('An error occurred while processing your request');
            } finally {
                stopLoading();
            }
        }
    };
    const handleChangeWalletAddress = async (from, type) => {
        setLinkingWalletModal({
            from,
            type,
        });
    };
    const { landscapes } = landscapesState;

    return (
        <Overlay>
            <div className="absolute rounded-lg left-[50%] p-6 w-[90%]   md:w-[40%]  bg-[#1C1C1C] border border-[#2a2a2a]   translate-x-[-50%] translate-y-[-50%] top-[50%]">
                <div ref={myRef} className="relative w-full h-full">
                    {!linkingWalletModal?.from && (
                        <button
                            className="  absolute z-[9999] top-0 right-0  rounded-full  "
                            onClick={() => {
                                close();
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                            >
                                <circle cx="15" cy="15" r="15" fill="#393939" />
                                <path
                                    d="M20.5918 10L10.5914 20.0004"
                                    stroke="#9B9B9B"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M20 20L9.99964 9.99964"
                                    stroke="#9B9B9B"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    )}

                    {linkingWalletModal?.from ? (
                        <div>
                            {linkingWalletModal?.type === 'metamask' && (
                                <div>
                                    <ChangeWallet
                                        close={close}
                                        handleChangeWalletAddress={handleChangeWalletAddress}
                                        type={linkingWalletModal?.type}
                                        linkedWallet={userProfile?.evmAddress}
                                        from={linkingWalletModal?.from}
                                    />
                                </div>
                            )}
                            {linkingWalletModal?.type === 'phantom' && <div>phantom connect karo </div>}
                        </div>
                    ) : isMinted ? (
                        <div className="flex flex-col relative items-center justify-center">
                            <p className="text-3xl  md:text-5xl w-full text-center absolute left-[50%] -translate-x-[50%] top-10  font-semibold">
                                New NFT Minted
                            </p>
                            <img src={mintedAnimation} alt="minted-animation" />
                        </div>
                    ) : (
                        <div>
                            <div className="flex flex-col  border-b border-[#2D2D2D] pb-4 ">
                                <p className="text-[#fff] text-2xl font-bold">Mint Now</p>
                                <p className="text-[#B2B2B2] text-sm ">
                                    A $5 as mint price will be required to mint a new NFT
                                </p>
                            </div>
                            <div className="mt-4">
                                <form action="" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="flex flex-col items-center w-full gap-6 mt-5 ">
                                        <div className="w-full">
                                            <p className="text-[#B2B2B2] font-semibold mb-1">
                                                {userProfile?.evmAddress || userProfile?.walletAddress
                                                    ? 'Wallets linked to Profile'
                                                    : 'No Wallet linked to Profile'}
                                            </p>

                                            <div
                                                className={`${
                                                    userProfile?.evmAddress && userProfile?.walletAddress
                                                        ? 'flex flex-col'
                                                        : 'flex items-center gap-3 '
                                                }`}
                                            >
                                                {userProfile?.evmAddress ? (
                                                    <div className="flex gap-2   ">
                                                        <img
                                                            className="w-7 h-7 object-cover rounded-full"
                                                            src={greenpillmetamask}
                                                            alt=""
                                                        />
                                                        <div>
                                                            <p className={`    `}>
                                                                <span className=" font-semibold">Linked Wallet:</span>
                                                                <span>
                                                                    {userProfile?.evmAddress.slice(0, 4)}...
                                                                    {userProfile?.evmAddress.slice(-4)}
                                                                </span>
                                                                <span
                                                                    onClick={() =>
                                                                        handleChangeWalletAddress('change', 'metamask')
                                                                    }
                                                                    className="text-[#0085FF] cursor-pointer ml-2 underline font-bold"
                                                                >
                                                                    change
                                                                </span>{' '}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <GradientBorder
                                                        radiusBorder={'.25rem'}
                                                        color2={'rgba(80, 108, 102, 0)'}
                                                        color1={'rgba(105, 159, 132, 1)'}
                                                        bg="bg-[#1E3D36]"
                                                        // shadow="shadow-button-shadow"
                                                    >
                                                        <button
                                                            onClick={() => linkHandler('metamask')}
                                                            type="button"
                                                            className={` px-4 py-2 flex items-center gap-2   justify-between`}
                                                        >
                                                            <img
                                                                className="w-7 h-7 object-cover rounded-full"
                                                                src={greenpillmetamask}
                                                                alt="metamask"
                                                            />
                                                            <span>Link Metamask</span>
                                                        </button>
                                                    </GradientBorder>
                                                )}
                                                {/* {userProfile?.walletAddress ? (
                                                    <div className="flex gap-2 w-full mt-2  ">
                                                        <img
                                                            className="w-7 h-7 object-cover rounded-full"
                                                            src={greenpillphantom}
                                                            alt=""
                                                        />
                                                        <div>
                                                            <p className={`    `}>
                                                                <span className=" font-semibold">Linked Wallet:</span>
                                                                <span>
                                                                    {userProfile?.walletAddress.slice(0, 4)}...
                                                                    {userProfile?.walletAddress.slice(-4)}
                                                                </span>
                                                                <span
                                                                    onClick={() =>
                                                                        handleChangeWalletAddress('change', 'phantom')
                                                                    }
                                                                    className="text-[#0085FF] cursor-pointer ml-2 underline font-bold"
                                                                >
                                                                    change
                                                                </span>{' '}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <GradientBorder
                                                        radiusBorder={'.25rem'}
                                                        color2={'rgba(80, 108, 102, 0)'}
                                                        color1={'rgba(105, 159, 132, 1)'}
                                                        bg="bg-[#1E3D36]"
                                                        // shadow="shadow-button-shadow"
                                                    >
                                                        <button
                                                            onClick={() => linkHandler('phantom')}
                                                            type="button"
                                                            className={` px-4 py-2 flex items-center gap-2   justify-between`}
                                                        >
                                                            <img
                                                                className="w-7 h-7 object-cover rounded-full"
                                                                src={greenpillphantom}
                                                                alt="metamask"
                                                            />
                                                            <span>Link Phantom</span>
                                                        </button>
                                                    </GradientBorder>
                                                )} */}
                                            </div>
                                        </div>
                                        <div className="w-full">
                                            <div className="w-full">
                                                <p className="text-[#B2B2B2] font-semibold">Choose Landscape</p>
                                                <div className="relative w-full ">
                                                    <Dropdown
                                                        data1Heading={
                                                            <div className="sticky top-0  bg-primaryBg z-10 ">
                                                                <p className="text-white">
                                                                    Funding Amount in Landscapes:
                                                                </p>
                                                                <p className="text-[#ADADAD] text-sm">
                                                                    Each landscape can only accommodate 400 fully
                                                                    transformed green pills. Ex, 50% means 200/400 slots
                                                                    for green pills have been filled
                                                                </p>
                                                            </div>
                                                        }
                                                        modifyLabel={(listItem) => {
                                                            return (
                                                                <span className="flex items-center text-[#A3A3A3] gap-5">
                                                                    <span>{listItem?.name} </span>
                                                                </span>
                                                            );
                                                        }}
                                                        data={landscapes}
                                                        selected={landscapeField.value}
                                                        onSelected={landscapeField.onChange}
                                                        modifySelected={(selected) => {
                                                            return (
                                                                <div className="flex items-center gap-5">
                                                                    <span className="text-[#A3A3A3]">
                                                                        {selected.name}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }}
                                                        noSelectedText="Choose Landscape"
                                                        btnClass=""
                                                        w="w-full"
                                                    />
                                                </div>
                                            </div>
                                            <p className="text-[#8C8C8C] text-sm font-semibold">
                                                {errors?.landscape && errors?.landscape?.message}
                                            </p>
                                        </div>

                                        <div className="w-full">
                                            <div className="w-full">
                                                <p className="text-[#B2B2B2] font-semibold">Chain to Mint on</p>
                                                <div className="relative w-full ">
                                                    <Dropdown
                                                        modifyLabel={(listItem) => {
                                                            return (
                                                                <span className="flex items-center text-[#A3A3A3] gap-5">
                                                                    <img
                                                                        className="w-5 h-5 rounded-full "
                                                                        src={listItem?.image}
                                                                        alt=""
                                                                    />
                                                                    {/* chainImage */}
                                                                    <span>{listItem?.name} </span>
                                                                </span>
                                                            );
                                                        }}
                                                        data={chains}
                                                        selected={tokenField.value}
                                                        onSelected={tokenField.onChange}
                                                        modifySelected={(selected) => {
                                                            return (
                                                                <div className="flex items-center gap-5">
                                                                    <div className="relative">
                                                                        <img
                                                                            className="w-5 h-5 rounded-full "
                                                                            src={selected?.image}
                                                                            alt=""
                                                                        />
                                                                    </div>

                                                                    <span className="text-[#A3A3A3]">
                                                                        {selected.name}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }}
                                                        noSelectedText="Choose Chain"
                                                        btnClass=""
                                                        w="w-full"
                                                    />
                                                </div>
                                            </div>
                                            <p className="text-[#8C8C8C] text-sm font-semibold">
                                                {Object.keys(errors)?.length === 2
                                                    ? 'Please choose a token and enter an amount'
                                                    : errors?.token?.message || errors?.totalRewardAmount?.message}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="mt-5 flex items-center justify-end">
                                        <button className=" bg-[#426A61] flex items-center py-3 px-4 justify-center gap-1 text-white border w-[11rem] border-[#699F84] rounded-lg ">
                                            {loading ? (
                                                <Loader color="fill-[#326F58]" />
                                            ) : (
                                                <>
                                                    <span>Mint Now</span> <ArrowRight size={14} />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Overlay>
    );
}

export default MintNFTModal;
